// Drives the scroll-progress indicator under the "What's in the box" carousel.
class TwtBoxContents extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('[data-box-scroll]');
    this.bar = this.querySelector('[data-box-progress]');
    if (!this.scroller || !this.bar) return;

    this.update = this.update.bind(this);
    this.scroller.addEventListener('scroll', this.update, { passive: true });
    window.addEventListener('resize', this.update);
    this.update();
  }

  disconnectedCallback() {
    if (!this.scroller) return;
    this.scroller.removeEventListener('scroll', this.update);
    window.removeEventListener('resize', this.update);
  }

  update() {
    const { scrollWidth, clientWidth, scrollLeft } = this.scroller;
    const ratio = scrollWidth > 0 ? clientWidth / scrollWidth : 1;
    const maxScroll = scrollWidth - clientWidth;
    const progress = maxScroll > 0 ? scrollLeft / maxScroll : 0;

    this.bar.style.setProperty('--twt-box-progress-width', `${Math.min(ratio, 1) * 100}%`);
    this.bar.style.setProperty(
      '--twt-box-progress-offset',
      `${progress * (1 / Math.min(ratio, 1) - 1) * 100}%`
    );
  }
}

customElements.define('twt-box-contents', TwtBoxContents);
